import { CONSTANTS } from '../../data.js';

// Memoized map of combinations for quick lookups
export const comboMap: Record<string, string> = (() => {
  const map: Record<string, string> = {};
  for (const c of CONSTANTS.combinations) {
    const a = (c.a || '').trim();
    const b = (c.b || '').trim();
    if (!a || !b) continue;
    const key = [a, b].sort().join('+');
    map[key] = c.result;
  }
  return map;
})();

/**
 * Given two element keys, returns the resulting element key if a valid
 * combination exists, otherwise undefined.
 */
export const combinePair = (aKey: string, bKey: string): string | undefined => {
  const key = [aKey, bKey].sort().join('+');
  return comboMap[key];
};

/**
 * Memoized map of recipes, keyed by the result element.
 */
export const recipesByResult: Record<string, { a: string; b: string }[]> = (() => {
  const map: Record<string, { a: string; b: string }[]> = {};
  for (const c of CONSTANTS.combinations) {
    const { a, b, result } = c;
    if (!a || !b || !result) continue;
    if (!map[result]) {
      map[result] = [];
    }
    map[result].push({ a, b });
  }
  return map;
})();
